import TinyOSS from 'pano-tiny-oss';
import { getExt } from 'pano-utils';
import { BucketType } from '@types';
import getFileMd5 from '@utils/getFileMd5';
import aliAuth from './aliAuth';

async function uploadThumb({ file, prefix }: { file: File; prefix: string }) {
  const resp = await aliAuth(BucketType.thumb);
  const md5 = await getFileMd5(file);
  const ext = getExt(file.name);
  const client = new TinyOSS({
    accessKeyId: resp.accessKeyId,
    accessKeySecret: resp.accessKeySecret,
    stsToken: resp.securityToken,
    bucket: resp.bucketName,
    endpoint: resp.endpointO,
    secure: true,
  });
  const url = `${prefix}/${md5}.${ext}`;
  await client.put(url, file, {
    headers: { 'x-oss-storage-class': 'IA' },
  });

  return url;
}

export default uploadThumb;
